<script setup>
defineProps({
  label: { type: String, default: 'Preparing the VIP lobby' },
  detail: { type: String, default: 'SECURE DESKTOP EXPERIENCE' }
});
</script>

<template>
  <section class="wanli-loader" role="status" aria-live="polite" :aria-label="label">
    <div class="wanli-loader-glow" aria-hidden="true" />
    <div class="wanli-loader-emblem">
      <i class="wanli-loader-ring outer" aria-hidden="true" />
      <i class="wanli-loader-ring inner" aria-hidden="true" />
      <img src="/assets/brand/wanli-script-gold-v1.webp" alt="Wanli" />
    </div>
    <div class="wanli-loader-rule" aria-hidden="true"><i /><span>WANLI</span><i /></div>
    <strong>{{ label }}</strong>
    <small>{{ detail }}</small>
    <div class="wanli-loader-progress" aria-hidden="true"><i /></div>
  </section>
</template>
